<div role="contentinfo" class="footer text-white text-center bg-primary">
  <div class="blue-line"></div>
  <div class="logos bg-primary row align-items-center justify-content-center m-0 py-4">
    <div class="col-12 my-2">
      <img class="skc-footer-image" [src]="'footer/partner-footer.png' | contentAssetImage" alt="footer image skc" />
    </div>
  </div>
  <div class="blue-line-2 mx-lg-5"></div>
  <div class="footer-text bg-primary d-flex align-items-center justify-content-center w-100">
    <div class="footer-content d-flex flex-column mx-auto">
      <img alt="" class="footer-logo" [src]="'logos/logo.svg' | contentAssetImage" draggable="false" />
      <span class="text-white font-size-14 text-center">{{ 'nav.club.rights' | translate }}</span>
    </div>
  </div>
</div>
